// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__l72Wk"};